import { useFormState } from 'react-final-form';

import {
  HorizontalRightsizingFormModelV2,
  WorkloadDetailsFormModel,
} from '../../../_types';
import { WorkloadHpaFormSettings } from '../_constants';

const isDefaultFormModelSettings: Record<
  WorkloadHpaFormSettings,
  (
    formModel: WorkloadDetailsFormModel<HorizontalRightsizingFormModelV2>
  ) => boolean
> = {
  basicBehavior: (formModel) => !formModel.horizontalRightsizing.isOverridden,
  metrics: (formModel) => !formModel.horizontalRightsizing.isOverridden,
  autoscalerBehavior: (formModel) =>
    !formModel.horizontalRightsizing.isOverridden,
};

export const useHpaSettingIsDefault = (
  settingName: WorkloadHpaFormSettings
) => {
  const form = useFormState<
    WorkloadDetailsFormModel<HorizontalRightsizingFormModelV2>
  >({
    subscription: { values: true },
  });

  return isDefaultFormModelSettings[settingName](form.values);
};
